<template>
	<div class="freight-detail-page">
		
		<!-- ===== 面包屑导航 + 返回按钮 ===== -->
		<div class="breadcrumb f-bct  animate__animated  ">
			<div class="breadcrumb-inner" @click="$router.back()">
				<span class="crumb-label">{{$t('ofee.t1')}}：</span>
				<span class="crumb-home">{{$t('ofee.t2')}}</span>
				<el-image class="crumb-sep" :src="require('@/static/CodeBuddyAssets/31159_1817/14.svg')"></el-image>
				<span class="crumb-home">{{$t('ofee.t3')}}</span>
				<el-image class="crumb-sep" :src="require('@/static/CodeBuddyAssets/31159_1817/14.svg')"></el-image>
				<span class="crumb-current">{{$t('ofee.t4')}}</span>
			</div>
			<!-- 返回按钮 -->
			<div class="back-btn" @click="$router.back()">
				<span>{{ $t('header.breadcrumb.backBtn') }}</span>
				<el-image class="back-icon" :src="require('@/static/CodeBuddyAssets/31159_2065/7.svg')"></el-image>
			</div>
		</div>

		<!-- ===== 主体内容区域 ===== -->
		<div class="main-content animate__animated  ">
			
			<!-- 左侧卡片：科特迪瓦空运快线 -->
			<div class="info-card shipping-card">
				<h2 class="card-title">{{transportLine.name}}</h2>
				
				<div class="card-fields">
					
					<div class="field-row">
						<div class="field-item">
							<label>{{$t('ofee.t5')}}：</label>
							<value v-if="transportLine.calculatePriceMode==1">{{$t('ofee.t6')}}</value>
							<value v-if="transportLine.calculatePriceMode==2">{{$t('ofee.t7')}}</value>
							<value v-if="transportLine.calculatePriceMode==3">{{$t('ofee.t8')}}</value>
							<value v-if="transportLine.calculatePriceMode==4">{{$t('ofee.t9')}}</value>
						</div>
					</div>
					
					<div class="field-row">
						<div class="field-item">
							<label>{{$t('ofee.t10')}}：</label>
							<value>{{order.countryName}}</value>
						</div>
					</div>
					
					<div class="field-row">
						<div class="field-item">
							<label>{{$t('ofee.t11')}}：</label>
							<value>{{order.weight}}kg</value>
						</div>
					</div>
					
					<div class="field-row">
						<div class="field-item">
							<label>{{$t('ofee.t12')}}：</label>
							<value>{{order.volume}}m³</value>
						</div>
					</div>
					
					<div class="field-row">
						<div class="field-item">
							<label>{{$t('ofee.t13')}}：</label>
							<value>￥{{order.freightPrice}}</value>
						</div>
					</div>
					
				</div>
			</div>

			<!-- 右侧卡片：计费标准 -->
			<div class="info-card standard-card">
				<h2 class="card-title card-title--dark">{{$t('ofee.t14')}}</h2>
				<div class="standard-fields">
					<div class="standard-field" v-for="(item,index) in transportLine.priceList">
						<label v-if="item.type==0">{{$t('ofee.t15')}}：</label>
						<value v-if="item.type==0">{{item.unitWeight}}kg</value>
						<label v-if="item.type==1">{{$t('ofee.t16')}}：</label>
						<value v-if="item.type==1">￥{{item.price}}/{{item.unitWeight}}KG</value>
					</div>
				</div>
				<div class="field-row">
					<div class="field-item field-note">
						<value>{{$t('ofee.t17')}}{{transportLine.maxWeight}}kg</value>
					</div>
				</div>
				
			</div>

		</div>
		
	</div>
</template>

<script>
import {
	transportOrderdetail,
} from "/src/api/api.js"
export default {
	name: 'OrderFeeDetailPage',
	data() {
		return {
			id: 0,
			order:'',
			transportLine:'',
		}
	},
	mounted() {
		this.id = this.$route.query.id
		this.transportOrderdetailF()
	},
	methods: {
		// 订单详情
		async transportOrderdetailF(){
			const res = await transportOrderdetail({id:this.id});
			if(res.code==200){
				this.transportLine = res.data.transportLine
				this.order = res.data.order
			}else{this.Tips(res.msg,'error')}
		},
	}
}
</script>

<style lang="scss" scoped>
/* ================================================================
   设计令牌 (Design Tokens)
   ================================================================ */

// 颜色
$c-primary:    #0096FF;
$c-text-dark:  #333333;
$c-text-gray:  #666666;
$c-text-muted: #999999;
$c-label:      #999999;
$c-border:     #EEEEEE;
$c-white:      #FFFFFF;

// 布局
$bg-page:       #F8F8F8;
$bg-card:       #FFFFFF;
$r-card:        12px;
$r-small:       8px;

// 字号
$fz-sm:   14px;
$fz-base: 16px;
$fz-lg:   18px;


/* ================================================================
   1. 页面根容器
   ================================================================ */
.freight-detail-page {
	width: 100%;
	min-height: 100vh;
	background: $bg-page;
	box-sizing: border-box;
	padding-bottom: 40px;
}


/* ================================================================
   2. 面包屑导航
   ================================================================ */
.breadcrumb {
	padding: 0 12px;
	padding-top: 24px;
	background: transparent;
	margin-bottom: 24px;
}
.breadcrumb-inner {
	display: flex;
	align-items: center;
}
.crumb-label {
	font-size: 0.16rem;
	font-weight: 400;
	color: #333333;
}
.crumb-home {
	font-size: 0.16rem;
	font-weight: 400;
	color: #666666;
	cursor: pointer;
	transition: color 0.3s;
	&:hover {
		color: #0096FF;
	}
}
.crumb-sep {
	width: 0.12rem;
	height: 0.12rem;
	margin: 0 0.06rem;
}
.crumb-current {
	font-size: 0.16rem;
	font-weight: 400;
	color: #0096FF;
}
/* ===== 返回按钮 ===== */
.back-btn {
	display: flex;
	align-items: center;
	cursor: pointer;
	transition: opacity 0.3s;
	&:hover { opacity: 0.75; }
	span {
		font-size: 0.16rem;
		font-weight: 400;
		color: #0096FF;
	}
	.back-icon {
		width: 0.18rem;
		height: 0.18rem;
		margin-left: 0.06rem;
	}
}


/* ================================================================
   3. 主体内容区域（左右两栏布局）
   ================================================================ */
.main-content {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	width: 1596px;
	margin: 0 auto;
	background: #fff;
	border-radius: 12px;
	padding: 24px;
}


/* ================================================================
   4. 通用卡片
   ================================================================ */
.info-card {
	background: $bg-card;
	border-radius: $r-card;
	box-sizing: border-box;
	height: 242px;
}

.card-title {
	font-family: 'PingFang SC', sans-serif;
	font-size: $fz-lg;
	font-weight: 500;
	color: $c-primary;
	margin-bottom: 20px;
	
	&--dark {
		color: $c-text-dark;
	}
}


/* ================================================================
   5. 运费信息卡片（左侧）
   ================================================================ */
.shipping-card {
	width: 760px;
	padding: 24px 32px;
	border: 1px solid $c-border;
	border-radius: $r-small;
}

.card-fields {
	display: flex;
	flex-direction: column;
}

.field-row {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 12px;
	
	&:last-child {
		margin-bottom: 0;
	}
}

.field-item {
	display: flex;
	align-items: flex-start;
	font-size: $fz-sm;
	width: 100%;
	
	label {
		color: $c-label;
		white-space: nowrap;
	}
	
	value {
		color: $c-text-dark;
		text-align: right;
		flex: 1;
	}
	
	&.field-note value {
		text-align: left;
	}
}


/* ================================================================
   6. 计费标准卡片（右侧）
   ================================================================ */
.standard-card {
	width: 760px;
	padding: 24px 32px;
	border: 1px solid $c-border;
	border-radius: $r-small;
}

.standard-fields {
	display: flex;
	flex-direction: column;
	margin-bottom: 12px;
}

.standard-field {
	display: flex;
	align-items: flex-start;
	font-size: $fz-sm;
	margin-bottom: 15px;
	
	&:last-child {
		margin-bottom: 0;
	}
	
	label {
		color: $c-label;
		white-space: nowrap;
	}
	
	value {
		color: $c-text-dark;
		text-align: right;
		flex: 1;
	}
}




/* ================================================================
   8. 无障碍：减少动画偏好
   ================================================================ */
@media (prefers-reduced-motion: reduce) {
	.animate__animated { animation: none !important; }
	*                { transition-duration: 0.01ms !important; }
}
</style>
